<template>
  <div>
    <Thetit :cn="cn"></Thetit>
    <div class="info">
      <div>
        <p>
          亿车——中国领先的城市级静态交通解决方案提供商和智慧停车运营商。公司以智慧停车为入口，深耕城市各类停车资源，将静态交通大数据与智慧城市服务深度结合，为城市管理者、停车经营管理方、车主和合作伙伴提供城市级静态交通综合解决方案、大数据应用和停车资产经营管理服务，致力解决城市“停车难，乱停车”问题。
        </p>
        <p>
          公司总部位于深圳，全国共设立5大营销片区，11家控股（参股）子公司。目前，已与国内300多座城市建立了商务合作关系，全平台停车位管理超过130万个，覆盖车主用户超过2200万人，停车总订单量超过5.6亿，不仅如此，亿车正积极努力拓展海外市场。
        </p>
        <p>
          2014年成立以来，亿车一直坚持“专业、开放、合作、共赢”的经营理念，以“路内停车“和“路外停车场”为核心，基于“位”延展至充电桩运营、立体车库、城市诱导、共享停车、分时租赁等多维度的静态交通服务，通过城市级静态交通一体化平台，归集智慧停车全方位业务数据，基于亿车开放平台，结合多维度服务场景，对停车大数据深度挖掘、分析和应用，实现动静态交通数据及行业内外数据的互联互通，为合作伙伴赋予互联网运营和增值服务的能力，最终为行业持续发展开发新领地。
        </p>
        <p>
          亿车50%以上是研发人员，拥有完善的自主研发体系，其中在车辆感知、视频识别/车牌识别、物联网、大数据、云计算及人工智能等方面已经拥有了深厚的技术积累
          ，目前亿车以“ 管理 + 运营 +
          服务+数据”的四轮驱动思想为指导，秉承开放共享，合作共赢的态度，积极向共享停车、车主服务、汽车金融等领域探索，逐步实现从产品到平台到生态的三级战略迭代，以数据驱动停车产业升级，构建智慧静态交通生态圈。
        </p>
      </div>
    </div>
    <!-- <div>
      <div class="btn" @click="playVideo">亿车介绍</div>
    </div> -->
    <div class="comment">
      <div class="cbox">
        <div>
          <p>公司使命</p>
          <div>让交通出行与人类生活更和谐</div>
        </div>
        <div>
          <p>核心价值观</p>
          <div>客户第一、长期奋斗、敢于担当、务实谦逊</div>
        </div>
      </div>
      <div
        class="cbox"
        style="display: flex;flex-direction: row;align-items: flex-start;"
      >
        <div>
          <p>公司愿景</p>
          <div>
            我们旨在共建面向未来并基于交通出行的各类新基础设施，成为产业链各方值得信赖的数字化合作伙伴。我们的愿景是实现人、车、位、桩、站、路等多个要素的网联化、在线化、智能化，让亿万人随时随地感知并获取无所不在的服务和数据。
          </div>
        </div>
        <div>
          <p>经营理念</p>
          <div>专业、开放、合作、共赢</div>
        </div>
      </div>
    </div>
    <div class="yearbox">
      <div class="title">
        <Thetit cn="亿车发展历程"></Thetit>
      </div>
      <div class="main">
        <div class="year rect">2020</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">
                2020年9月，亿车乔迁新址
              </p>
              <div class="left">
                深圳总部搬迁至南山区科兴科学园B1栋4楼<br/>
                开启新的事业征程
              </div>
            </div>
          </div>
          <div style="padding-top:15px;max-width:400px">
            <div class="mt31">
              <p class="circle1">
                2020年5月，东莞市莞城区智慧停车项目上线
              </p>
              <div class="right">
                这是亿车继深圳、中山、江门、香港后的又一个粤港澳大湾区城市级智慧停车案例，继续扩大这一区域的市场份额
              </div>

            </div>
            <div class="mt31">
              <p class="circle1">
                2020年4-8月，亿车陆续中标丽江市玉龙县、华坪县和永胜县智慧停车项目
              </p>
              <div class="right">
                继2019年丽江市古城区智慧停车项目上线后
                <br />
                亿车陆续中标丽江市玉龙县、华坪县和永胜县智慧停车项目
                <br />
                在国内率先推出支持向下扩容的市-县（区）两级平台管控模式
                <br />
                帮助客户快速实现停车资源整合与统一运营
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="year rect">2019</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">
                2019年12月，亿车“航”系列解决方案“领航”版进驻南京
              </p>
              <div class="left">
                亿车在南京市搭建城市级“数据领航中心”
                <br />
                标志着亿车“航”全系列产品已在国内全面铺开
              </div>
            </div>
          </div>
          <div style="padding-top:15px;max-width:400px">
            <div class="mt31">
              <p class="circle1">
                2019年6月，湖州智慧停车项目
              </p>
              <div class="right">
                亿车国内首创，采用城市3D建模技术运用在湖州项目
                <br />
                让城市停车大数据得到立体化直观呈现
              </div>
              <div>标志着亿车全新升级的静态交通大数据云平台5.0即将落地</div>
            </div>
            <div class="mt31">
              <p class="circle1">
                2019年1月，全国首例“智慧口岸+智慧停车”创新应用落地
              </p>
              <div class="right">
                亿车联合深圳口岸中心、腾讯微信支付
                <br />
                打造全国首例 “智慧口岸+智慧停车”创新应用
                <br />
                共同实现深圳湾、福田等五大陆路口岸，“免扫码不停车、2秒过闸，无感支付停车全打通”的智慧停车服务
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="year rect">2018</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">
                2018年12月，亿车与中国工商银行总部签署战略合作协议
              </p>
              <div class="left">亿车与中国工商银行总部达成合作</div>
              <div>双方探索多业务合作方向，共建“智慧停车+科技金融”新场景</div>
            </div>
            <div class="mt31">
              <p class="circle">
                2018年12月，亿车“航”系列解决方案“巡航”版走进丽江古城区
              </p>
              <div class="left">
                亿车走进全国文明风景旅游区——丽江市古城区
              </div>
              <div>
                标志着亿车“航”系列解决方案“巡航”版 已经被市场广泛认可<br />即将在国内各大城市全面铺开
              </div>
            </div>
            <div style="margin-top: 60px;">
              <p class="circle">
                2018年10月，亿车“航”系列解决方案“启航”版项目首次落地
              </p>
              <div class="left">亿车进驻湖北省应城市和宜昌远安县城</div>
              <div>这标志着亿车“航”系列产品真正开始从规划走向落地应用</div>
            </div>
          </div>
          <div style="padding-top:150px;max-width:400px">
            <div class="mt31">
              <p class="circle1">
                2018年11月，亿车“航”系列解决方案“巡航”版项目落地
              </p>
              <div class="right">
                亿车连下丝绸之路两大重镇西安市和乌鲁木齐市
              </div>
              <div>这标志着亿车“航”系列产品已具备足够的市场空间与开发潜力</div>
            </div>
            <div class="mt31">
              <p class="circle1">2018年8月，亿车“航”系列解决方案重磅推出</p>
              <div class="right">
                亿车四年寒窗磨一剑，历经70多个城市级项目的历练
              </div>
              <div>
                与沉淀，潜心研发出
                “航”系列城市级静态交通运营管理产品与解决方案！
                “航”系列一共分为三大产品系列：“启航”、“巡航”、“领航”
              </div>
            </div>
          </div>
        </div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">
                2018年6月，亿车成为云南“一机游”项目的智慧停车场服务商
              </p>
              <div class="left">
                亿车成为了“一部手机游云南”项目的智慧停车场景合作伙伴
              </div>
              <div>
                助力“一部手机游云南”项目实现云南多个景区智慧停车场上线
                <br />全力打造云南全域旅游的线上线下智慧停车场景解决方案
              </div>
            </div>
            <div class="mt31">
              <p class="circle">2018年6月，东莞市行政中心广场公共停车场项目</p>
              <div class="left">亿车中标东莞市行政中心广场公共停车场项目</div>
              <div>
                项目覆盖16个停车场近2000个泊位，是亿车又一大型停车经营权项目
              </div>
            </div>
            <div class="mt31">
              <p class="circle">
                2018年6月，亿车获选为深圳停车产业化联盟理事单位
              </p>
              <div class="left">深圳停车产业化联盟成立</div>
              <div>
                亿车成为联盟八家理事单位之一，宣示了亿车在深圳停车行业的主力军地位
              </div>
            </div>
            <div style="margin-top: 110px;">
              <p class="circle">2018年4月，亿车与江苏绿金金融战略合作</p>
              <div class="left">亿车与江苏绿金金融达成合作</div>
              <div>
                致力于打造以“大云平移”为特征的城市静态管理系统与绿色金融产业相融合的产融结合模式的新型业态
              </div>
            </div>
          </div>
          <div style="padding-top:300px;max-width:400px">
            <div class="mt31">
              <p class="circle1">2018年5月，雄安首个NB-IoT智慧停车场上线</p>
              <div class="right">
                亿车携手中国移动联合打造雄安新区首个NB-IoT智慧停车场
              </div>
              <div>
                以“NB-IoT+互联网+停车场”新型组合，实现了基于NB-IoT技术的新一代智慧停车场的落地
              </div>
            </div>
            <div class="mt31">
              <p class="circle1">
                2018年3月，云南省红河州州府蒙自市路内停车项目
              </p>
              <div class="right">
                亿车签约云南省红河州州府蒙自市路内停车项目
              </div>
              <div>
                项目覆盖8000个临时占道泊位，是目前国内最大的NB地磁应用的路内停车案例
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main" style="margin-top: 53px">
        <div class="year rect year2017">2017</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">2017年12月，亿车与出租宝战略合作</p>
              <div class="left">亿车与出租宝达成战略合作</div>
              <div>实现以“智慧城中村+智慧停车”模式共建平安社区</div>
            </div>

            <div class="mt31">
              <p class="circle">2017年12月，沈阳首个无人值守停车场项目落地</p>
              <div class="left">亿车携手捷安泊打造辽宁省中医院无人化停车场</div>
              <div>成为沈阳首个无人值守停车场</div>
            </div>

            <div class="mt31">
              <p class="circle">2017年12月，推出全视频智慧停车解决方案</p>
              <div class="left">
                亿车首次推出全视频智慧停车解决方案，并将全视频技术成功
              </div>
              <div>整合入城市级静态交通一体化运营平台</div>
            </div>
            <div class="mt208">
              <p class="circle">2017年9月，香港首个NB-IoT商用案例落地</p>
              <div class="left">
                亿车助力香港首个NB-IoT商用案例落地，亿车CEO佘志登作为
              </div>
              <div>特邀嘉宾，参加中国移动香港商用NB-IoT应用展示会</div>
            </div>
            <div class="mt31">
              <p class="circle">2017年7月，A+轮融资</p>
              <div class="left">
                公司完成4000万元A+轮融资，由盛势资本领投，泰丰富盛股权
              </div>
              <div>投资基金跟投</div>
            </div>
            <div class="mt31">
              <p class="circle">2017年5月，车主用户破千万</p>
              <div class="left">
                公司全平台各项服务覆盖的车主用户数突破千万，产品口碑进
              </div>
              <div>一步提升</div>
            </div>
          </div>
          <div style="padding-top:240px">
            <div>
              <p class="circle1">2017年11月，亿车与南方和顺战略合作</p>
              <div class="right">
                亿车与南方和顺达成全面战略合作，共同推进城市级“停车+充
              </div>
              <div>电”一体化运营服务，首批充电设施在宜停车泊位正式启用</div>
            </div>
            <div class="mt31">
              <p class="circle1">2017年11月，西安无人值守项目上线</p>
              <div class="right">
                亿车NB地磁助力西安“无人值守，自主缴费”项目落地，成为
              </div>
              <div>当前国内最大规模基于NB技术的智慧停车应用案例</div>
            </div>
            <div class="mt31">
              <p class="circle1">2017年11月，城市静态交通一体化平台4.0上线</p>
              <div class="right">
                亿车城市静态交通一体化平台全新升级4.0，实现路内
              </div>
              <div>外停车与充电一体化</div>
            </div>
            <div class="mt31">
              <p class="circle1">2017年8月，任丘智慧停车项目</p>
              <div class="right">中标任丘市智慧停车总集成项目</div>
              <div>是当前国内覆盖城市静态交通业务范围最广的项目</div>
            </div>
            <div class="mt31">
              <p class="circle1">2017年6月，服务订单量破亿</p>
              <div class="right">
                全平台的停车、充电、增值服务等订单总数量，突破1亿次
              </div>
            </div>
            <div class="mt31">
              <p class="circle1">2017年3月，发布NB-IoT应用</p>
              <div class="right">
                基于NB-IoT技术，发布包括传感器、智能设备终端、无线传输
              </div>
              <div>
                模块等硬件产品，并应用于公司的多条产品线，推动在物联网及
              </div>
              <div>智慧交通领域的全面升级</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="year rect year2016">2016</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">2016年12月，积极对外合作</p>
              <div class="left">
                成为腾讯互联网+战略合作伙伴，并与阿里、华为、高通、移动、
              </div>
              <div>联通、电信、西门子、浪潮等各领域优秀企业进行战略合作</div>
            </div>
            <div class="mt31">
              <p class="circle">2016年10月，获总理发送第一个创业红包</p>
              <div class="left">
                全国“双创周” 李克强总理通过网络为广大创客发放创业红包，亿
              </div>
              <div>车科技CEO佘志登成为第一个领取红包的创业者</div>
            </div>
            <div class="mt31">
              <p class="circle">2016年3月，公众停车宝上线</p>
              <div class="left">
                参与国内第二例城市级路内智慧停车项目（天津 · 公众停车
              </div>
              <div>宝）的成功实施和上线运行</div>
            </div>
          </div>
          <div>
            <div style="padding-top:15px;max-width:400px">
              <p class="circle1">2016年11月，全国快速布局</p>
              <div class="right">
                在全国完成5大营销片区共12个办事处的布局落地，陆续
              </div>
              <div>成立9家控股（参股）子公司</div>
            </div>
            <div class="mt31">
              <p class="circle1">2016年9月，签约停车场破千</p>
              <div class="right">
                签约的封闭式停车场数量突破1000个，合计管理泊位数超过60万个
              </div>
            </div>
            <div class="mt31">
              <p class="circle1">2016年2月，完成A轮融资</p>
              <div class="right">
                获得由腾讯、泓锦文并购基金、同创伟业、远致创投、坤鼎车联网产
              </div>
              <div>业基金共同出资的 8000 万元 A轮融资</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="year rect year2015">2015</div>
        <div class="yearinfo">
          <div>
            <div>
              <p class="circle">2015年11月，车主用户超百万</p>
              <div class="left">
                公司全平台覆盖的车主用户数突破百万，用户使用服务的月
              </div>
              <div>活比例超过50%</div>
            </div>
            <div class="mt31">
              <p class="circle">蜜蜂停车，2015年8月</p>
              <div class="left">
                正式推出面向封闭式停车场联网管理&运营的产品—蜜蜂停车APP及
              </div>
              <div>行业解决方案</div>
            </div>
          </div>
          <div>
            <div>
              <p class="circle1">2015年10月，骆驼快充上线</p>
              <div class="right">
                面向电动汽车用户，推出涵盖充电预约、计费结算、充电桩联网等
              </div>
              <div>服务的能源管理和运营解决方案（骆驼快充）</div>
            </div>
            <div class="mt31">
              <p class="circle1">2015年1月，宜停车上线</p>
              <div class="right">
                参与国内第一例“互联网+智慧停车”应用案例（深圳 · 宜停车）的成
              </div>
              <div>功实施和上线运行</div>
            </div>
            <div class="mt31">
              <p class="circle1">2015年1月，Pre A轮融资</p>
              <div class="right">
                获得鹏德创投及国家发改委互联网引导基金两只基金共计1000
              </div>
              <div>万元的天使轮投资</div>
            </div>
          </div>
        </div>
      </div>
      <div class="year">
        <p>2014/11</p>
        <p>亿车成立</p>
      </div>
    </div>
    <div class="honer">
      <Thetit cn="公司荣誉"></Thetit>
      <div class="honerbox">
        <div>
          <div>
            <div class="imgbox">
              <img src="~@/common/img/ecaray_about_introduction_honor01.png" />
            </div>
            <div class="imginfo">2018最具投资价值新星企业百强榜</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor02.png"
              />
            </div>
            <div class="imginfo">智慧停车优秀解决方案提供商</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor03.png"
              />
            </div>
            <div class="imginfo">中国移动5G联合创新中心合作伙伴</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor04.png"
              />
            </div>
            <div class="imginfo">《停车场信息联网通用技术规范》</div>
            <div style="margin-top:24px;">标准制定单位</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox mt64">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor05.png"
              />
            </div>
            <div class="imginfo">智慧交通品牌产品</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor06.png"
              />
            </div>
            <div class="imginfo">智慧交通创新产品</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                class="w234"
                src="~@/common/img/about/ecaray_about_introduction_honor07.png"
              />
            </div>
            <div class="imginfo">中国城市智慧停车十佳创新品牌</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                class="w234"
                src="~@/common/img/about/ecaray_about_introduction_honor08.png"
              />
            </div>
            <div class="imginfo">应用创新企业</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox">
              <img
                class="w199"
                src="~@/common/img/about/ecaray_about_introduction_honor09.png"
              />
            </div>
            <div class="imginfo">道路停车行业成长型示范企业</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                class="w199"
                src="~@/common/img/about/ecaray_about_introduction_honor10.png"
              />
            </div>
            <div class="imginfo">道路停车行业智能化平台示范企业</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor11.png"
              />
            </div>
            <div class="imginfo">企业信用评价AAA级信用企业</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor12.png"
              />
            </div>
            <div class="imginfo">智能交通推荐技术方案</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor13.png"
              />
            </div>
            <div class="imginfo">中国智能停车行业十大优秀企业</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor14.png"
              />
            </div>
            <div class="imginfo">中国停车行业金泊奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor15.png"
              />
            </div>
            <div class="imginfo">新能源汽车充电最佳服务商</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor16.png"
              />
            </div>
            <div class="imginfo">最佳静态交通解决方案服务商</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor17.png"
              />
            </div>
            <div class="imginfo">中国互联网+智慧停车最佳解决方案奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor18.png"
              />
            </div>
            <div class="imginfo">中国互联网+智慧停车贡献企业奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor19.png"
              />
            </div>
            <div class="imginfo">中国互联网+智慧停车最佳产品奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor20.png"
              />
            </div>
            <div class="imginfo">2016年度智慧交通品牌产品</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor21.png"
              />
            </div>
            <div class="imginfo">优秀停车App</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor22.png"
              />
            </div>
            <div class="imginfo">智能化平台示范企业</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor23.png"
              />
            </div>
            <div class="imginfo">智慧停车优秀解决方案提供商</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor24.png"
              />
            </div>
            <div class="imginfo">最具商业价值公司</div>
          </div>
        </div>
        <div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor25.png"
              />
            </div>
            <div class="imginfo">第七届中国（深圳）创新创业大赛奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor26.png"
              />
            </div>
            <div class="imginfo">“创业之星”优胜奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor27.png"
              />
            </div>
            <div class="imginfo">智慧交通创新产品奖</div>
          </div>
          <div>
            <div class="imgbox">
              <img
                src="~@/common/img/about/ecaray_about_introduction_honor28.png"
              />
            </div>
            <div class="imginfo">众创新星奖杯</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Thetit from './title';
import videoPlayer from '@/components/video-player';
import { getVod } from '@/api/portal';
export default {
  data() {
    return {
      cn: '亿车介绍',
      videoInfo: {
        title: '亿车品牌介绍',
        videoSrc: '',
      },
    };
  },
  components: {
    Thetit,
  },
  created() {
    this.getVod();
  },
  methods: {
    playVideo() {
      videoPlayer(this.videoInfo);
    },
    getVod() {
      getVod({
        is_read: 1,
        id: '20180813111718114377752431935298',
        width: 0,
        height: 0,
      }).then(res => {
        if (res.state != 1) return;
        this.videoInfo.videoSrc = res.data.vodUrl;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  > div {
    display: inline-block;
    vertical-align: top;
  }
  width: 860px;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.68);
  padding: 32px 0;
  height: auto;
  font-size: 0;
  p {
    line-height: 1.8;
    font-size: 14px;
    &:not(:first-child) {
      margin-top: 32px;
    }
  }
}
.btn {
  width: 124px;
  height: 40px;
  box-sizing: border-box;
  margin: 43px auto 61px;
  color: #2f98e9;
  border: 1px solid #2f98e9;
  border-radius: 8px;
  line-height: 40px;
  font-size: 14px;
  background: url('~@/common/img/vid.png') no-repeat 12px 8.5px;
  padding-left: 44px;
  cursor: pointer;
}

.comment {
  height: 500px;
  background: url('~@/common/img/aboutecaray_01.jpg') no-repeat center center;
  padding-top: 56px;
  box-sizing: border-box;
  background-size: cover;
}

.cbox {
  width: 1176px;
  margin: 0 auto;
  > div {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    &:first-child {
      width: 551px;
      margin-right: 100px;
    }
  }
}

.comment .cbox:last-child {
  margin-top: 70px;
}

.cbox {
  p {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.56);
  }
  div {
    font-size: 24px;
    color: #fff;
    margin-top: 15px;
  }
}

.title {
  padding: 98px 0 149px;
}

.main {
  width: 1124px;
  margin: 0 auto;
  position: relative;
}

.year {
  font-size: 40px;
  color: rgba(0, 0, 0, 0.88);
  text-align: center;
  margin-bottom: 69px;
  background-color: #fff;
}

.yearinfo {
  font-size: 0;
  > div {
    display: inline-block;
    vertical-align: top;
    &:first-child {
      text-align: right;
      margin-right: 168px;
      width: 480px;
    }
    &:last-child {
      text-align: left;
      padding-top: 35px;
    }
  }
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
  }
  > div div {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.64);
  }
}

.rect {
  position: relative;
  z-index: 2;
  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.12);
    top: -50px;
    left: 50%;
    z-index: 1;
  }
  &.year2017:before {
    top: -53px;
  }
  &.year2016:before {
    top: -85px;
  }
  &.year2015:before {
    top: -85px;
  }
}

.main::after {
  content: '';
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.12);
  // top: 80px;
  top: 0;
  left: 50%;
  z-index: 1;
}

.mt208 {
  margin-top: 208px;
}

.mt31 {
  margin-top: 31px;
}

.circle,
.circle1,
.left,
.right {
  position: relative;
}

.circle {
  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #dedede;
    right: -88px;
    top: 3px;
    z-index: 3;
    border-radius: 50%;
  }
  &::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: #fff;
    right: -95px;
    top: -4px;
    z-index: 2;
    border-radius: 50%;
  }
}

.circle1 {
  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #dedede;
    left: -90px;
    top: 3px;
    z-index: 3;
    border-radius: 50%;
  }
  &::after {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: #fff;
    left: -97px;
    top: -4px;
    z-index: 2;
    border-radius: 50%;
  }
}

.left::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  background-color: #dedede;
  right: -72px;
  top: -23px;
}

.right::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  background-color: #dedede;
  left: -76px;
  top: -23px;
}

.yearbox > div {
  &:nth-child(3) {
    margin-top: 53px;
  }
  &:nth-child(4),
  &:nth-child(5) {
    margin-top: 85px;
  }
}

.honer {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 93px 0 101px;
}

.honerbox {
  width: 1176px;
  margin: 133px auto 0;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.08);
  > div {
    > div {
      display: inline-block;
      vertical-align: bottom;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
      width: 293px;
      text-align: center;
      height: 369px;
      box-sizing: border-box;
      padding: 24px 0 24px 0;
      position: relative;
    }
    font-size: 0;
    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
    > div:not(:last-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.08);
    }
  }
}

.imginfo {
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  position: absolute;
  padding: 40px 0;
}

.imgbox {
  height: 283px;
  line-height: 283px;
}

// .w199 {
//   width: 199px;
// }

// .w234 {
//   width: 234px;
// }
</style>
